import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Box, InputAdornment, IconButton, FormHelperText } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useParams } from 'react-router-dom';




const ResetPassword = () => {
    const [passwords, setPasswords] = useState({
        newPassword: '',
        repeatPassword: '',
    });
    const handleClick = () => {
        // Construct the URL for an external link
        const url = `https://${loginUrl}/login/${basketId}`;
        window.location.href = url;
        // console.log(url);
    };
    
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [passwordSet, setPasswordSet] = useState(false)

    const apiBaseUrlAPI1 = process.env.REACT_APP_API_BASE_URL;
    const loginUrl = process.env.REACT_APP_FRONTEND_BOOKING_URL1;

    const handlePasswordChange = (prop) => (event) => {
        setPasswords({ ...passwords, [prop]: event.target.value });
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleShowRepeatPassword = () => {
        setShowRepeatPassword(!showRepeatPassword);
    };

    const params = useParams();
    const activkey = params.activekey;
    const basketId = params.basketId;

    // console.log("check", activkey, basketId)

    const handleSave = async (event) => {
        event.preventDefault();

        // Check for empty fields
        if (!passwords.newPassword || !passwords.repeatPassword) {
            setPasswordError('Both fields are required.');
            return; // Stop the function if any field is empty
        }

        // Check if the passwords match
        if (passwords.newPassword !== passwords.repeatPassword) {
            setPasswordError('Passwords do not match.');
            return; // Stop the function if the passwords don't match
        }

        // If validation passes, clear the error and proceed with the API call
        setPasswordError('');

        // Create the payload
        const payload = {
            "basket": {
                "id": basketId// replace with actual basket ID from your state or props
            },
            "user": {
                "password": passwords.newPassword,
                "activkey": activkey // replace with actual activkey from your state or props
            }
        };
        // Perform the API call
        try {
            const response = await fetch(`${apiBaseUrlAPI1}/user/reset`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                // const data = await response.json();
                // Handle success response
                // console.log('Password reset successful', data);
                setPasswordSet(true);
                // You might want to navigate to another page or show a success message
            } else {
                // Handle non-200 responses
                // console.error('Password reset failed', response.status, await response.text());
                
            }
        } catch (error) {
            // Handle network errors or other unexpected issues
            // console.error('Network or other error', error);
            setPasswordError('An error occurred. Please try again.');
        }
    };


    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Change Password
                </Typography>
               
                {passwordSet ? (
                    <div>
                        <p>Your password has been changed, please login to continue with your booking.</p>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                style={{ display: 'flex', justifyContent: 'center' }}
                                onClick={handleClick}
                            >
                                Great, let's continue
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div>
                         <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    Fields with <span style={{ color: 'red' }}>*</span> are required
                </Typography>
                    <Box component="form" noValidate sx={{ mt: 1 }} onSubmit={handleSave}>
                        <TextField
                            variant="outlined"
                            margin="normal"

                            fullWidth
                            name="newPassword"
                            label={
                                <>
                                    New Password <span style={{ color: 'red' }}>*</span>
                                </>
                            }
                            type={showPassword ? 'text' : 'password'}
                            id="newPassword"
                            autoComplete="new-password"
                            onChange={handlePasswordChange('newPassword')}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockOutlinedIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={toggleShowPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"

                            fullWidth
                            name="repeatPassword"
                            label={
                                <>
                                    Repeat Password <span style={{ color: 'red' }}>*</span>
                                </>
                            }
                            type={showRepeatPassword ? 'text' : 'password'}
                            id="repeatPassword"
                            autoComplete="new-password"
                            onChange={handlePasswordChange('repeatPassword')}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockOutlinedIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={toggleShowRepeatPassword}
                                            edge="end"
                                        >
                                            {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <FormHelperText error={!!passwordError}>
                            {passwordError}
                        </FormHelperText>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Save
                        </Button>
                    </Box>
                    </div>
                )}
            </Box>
        </Container>
    );
};

export default ResetPassword;
